<template>
  <div class="first-word">
    {{firstLetter}}
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
    export default {
        name: "firstLetter",
      computed: {
        ...mapGetters(['userInfo']),
        firstLetter(){
          return this.userInfo.firstName.toUpperCase().charAt(0);
        }
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/variable.scss";
  .first-word {
    width: 40px;
    height: 40px;
    background-color: $themeColor;
    border-radius: 50%;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
</style>
